<template>  
  <button class="btn btn-danger my-2 my-sm-0" type="submit" @click.prevent="action">
    <fa-icon :icon="icon"/>
    {{ label }}
  </button>
</template>

<script>
export default {
  name: 'disconnect',
  props: ['device'],
  data () {
    return {
      connected: false,
      label: 'Disconnect',
      icon: 'unlink'
    }
  },
  methods: {
    action (e) {
      e.target.blur()

      const p = this.device.stop()
      p.finally(this.device.disconnect)
    }
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/Disconnect.vue